import {h, Fragment} from "preact"
import Product from "./Product"
import { useAppState } from "@nosto/preact"
import { useEffect } from "preact/hooks"

export default function Products({swatchData}) {
    const {
        response: { products },
        loading
    } = useAppState()

    // useEffect(() => {
    //     Nosto.migrateToShopifyMarket({
    //         productSectionElement: '.ns-serp .nosto-product-info',
    //         productHandleAttribute: 'x-nosto-handle',
    //         priceElement: '.ns-serp .nosto-newprice',
    //         listPriceElement: '.ns-serp .nosto-oldprice',
    //     })
    // })

    return (
        <div class="ns-product-list ns-d-flex ns-flex-wrap" style={loading ? "opacity: 0.3;" : ""}>
            {products.hits.map((hit, index) => {
                return <Product swatchData={swatchData} product={hit} key={hit.productId || index} />
            })}
        </div>
    )
}
